// store/modules/tagitr.js
export default {
    namespaced: true,
    state: {
        details: null, // 存储 Details 数据
    },
    mutations: {
        setDetails(state, details) {
            state.details = details;
        },
    },
    actions: {
        updateDetails({ commit }, details) {
            commit('setDetails', details);
        },
    },
    getters: {
        getDetails(state) {
            return state.details;
        },
    },
};